import React from "react";
import { Link } from "react-router-dom";
import "./login.css";

class RegisterView extends React.Component {
  state = {
    name: "",
    surname: "",
    email: "",
    password: "",
    confirmPassword: "",
    error: null,
    submitting: false,
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value, error: null });
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  submit = () => {
    const { name, surname, email, password, confirmPassword } = this.state;

    if (!name.trim() || !surname.trim()) {
      this.setState({ error: "Name and surname are required" });
      return;
    }
    if (!this.validateEmail(email)) {
      this.setState({ error: "Please enter a valid email address" });
      return;
    }
    if (!password || password.length < 6) {
      this.setState({ error: "Password must be at least 6 characters" });
      return;
    }
    if (password !== confirmPassword) {
      this.setState({ error: "Passwords do not match" });
      return;
    }

    this.setState({ submitting: true, error: null });
    this.props.dispatchRegister({
      name: name.trim(),
      surname: surname.trim(),
      username: email.trim().toLowerCase(),
      password,
      confirmPassword,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.registerError && this.props.registerError !== prevProps.registerError) {
      this.setState({ submitting: false, error: this.props.registerError });
    }
  }

  render() {
    if (this.props.user && this.props.user._id) {
      return null; // Will redirect via Routes
    }

    const { name, surname, email, password, confirmPassword, error, submitting } = this.state;
    const isValid =
      name.trim() &&
      surname.trim() &&
      this.validateEmail(email) &&
      password.length >= 6 &&
      password === confirmPassword;

    return (
      <div className="login-container">
        <div className="login-card">
          <Link to="/">
            <img
              src="/moneyapp_blue.png"
              alt="MoneyApp Logo"
              className="login-logo"
            />
          </Link>
          <h1 className="login-title">create account</h1>
          <hr className="login-divider" />

          {error && (
            <div className="alert alert-danger">{error}</div>
          )}

          <form onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="First Name"
                data-testid="register-name"
                value={name}
                onChange={(e) => this.handleChange("name", e.target.value)}
                autoFocus
              />
              <i className="fas fa-user form-icon"></i>
            </div>

            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Last Name"
                data-testid="register-surname"
                value={surname}
                onChange={(e) => this.handleChange("surname", e.target.value)}
              />
              <i className="fas fa-user form-icon"></i>
            </div>

            <div className="form-group">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                data-testid="register-email"
                value={email}
                onChange={(e) => this.handleChange("email", e.target.value)}
              />
              <i className="fas fa-envelope form-icon"></i>
            </div>

            <div className="form-group">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                data-testid="register-password"
                value={password}
                onChange={(e) => this.handleChange("password", e.target.value)}
              />
              <i className="fas fa-lock form-icon"></i>
            </div>

            <div className="form-group">
              <input
                type="password"
                className="form-control"
                placeholder="Confirm Password"
                data-testid="register-confirm"
                value={confirmPassword}
                onChange={(e) => this.handleChange("confirmPassword", e.target.value)}
              />
              <i className="fas fa-lock form-icon"></i>
            </div>

            <button
              type="submit"
              className="login-button"
              data-testid="register-submit"
              disabled={!isValid || submitting}
              style={{ opacity: (!isValid || submitting) ? 0.6 : 1 }}
            >
              {submitting ? "Creating Account..." : "Sign Up"}
            </button>
          </form>

          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <Link to="/login" style={{ color: "#666", fontSize: "0.9rem" }}>
              Already have an account? <span style={{ color: "#007bff", fontWeight: 600 }}>Sign In</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default RegisterView;
